export default __webpack_public_path__ + "static/media/van.7ea4845f.svg";